import React, { useCallback, useEffect, useState } from "react";
import Layout from "../../Layout";
import * as RB from "react-bootstrap";
import {
  Link,
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";
import CustomPagination from "../../Utils/CustomPagination";
import DataTable from "react-data-table-component";
import * as utils from "../../Utils/comman";
import { Eye } from "iconsax-react";
import moment from "moment";
import ReasonModal from "../ReasonModal";

function EmployeeAmountDetail() {
  const navigate = useNavigate();
  const { id } = useParams();
  const location = useLocation();

  const queryParams = new URLSearchParams(location.search);
  const type = queryParams.get("type");
  const keyPersonId = queryParams.get("keyPerson");
  const tabKey = queryParams.get("tabKey");
  const [data, setData] = useState({ result: [], total: 0 });
  const [page, setPage] = useState(1);
  const countPerPage = 10;

  const [showModal, setShowModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [showReasonModal, setShowReasonModal] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [modalText, setModalText] = useState("");
  // Meeting columns
  const meetingColumns = [
    { name: <>Meeting No</>, selector: (row) => row.meeting_no },
    {
      name: <>Meeting Date</>,
      selector: (row) => moment(row.meeting_date).format("DD-MM-YYYY"),
    },

    { name: <>Subject Name</>, selector: (row) => row.subject_name },
    { name: <>City</>, selector: (row) => row.city },
    { name: <>Retailer/Architect Name</>, selector: (row) => row.counter_name },
    ...(tabKey === "teamCounter"
      ? [
          {
            name: <>Employee Name</>,
            selector: (row) => `${row.firstName} ${row.lastName}`,
          },
        ]
      : []),
    { name: <>Amount</>, selector: (row) => row.brand_final_amt },
  ];

  // Branding columns
  const brandColumns = [
    {
      name: (
        <div>
          Requested Date <br />
        </div>
      ),
      selector: (row) => moment(row?.createdAt).format("DD-MM-YYYY"),
    },
    ...(tabKey === "teamCounter"
      ? [
          {
            name: "Employee Name",
            selector: (row) => `${row.emp_name}`,
          },
        ]
      : []),
    // { name: <>Subject</>, selector: (row) => row.subject },
    { name: <>Subject</>, selector: (row) => row.subject },
    {
      name: (
        <div>
          Subject Detail(Description) <br />
        </div>
      ),
      selector: (row) => row.subject_detail,
      cell: (row) => {
        const wordCount = row.subject_detail?.split(" ").length;
        return wordCount > 2 ? (
          <RB.Button
            className="btn btn-flat"
            onClick={handleShowModal(
              "Subject Detail(Description)",
              row.subject_detail,
            )}
          >
            <Eye />
          </RB.Button>
        ) : (
          <span>{row.subject_detail}</span>
        );
      },
    },
    {
      name: "Branding Amount",
      selector: (row) => row.total_amt,
    },
  ];
  const handleShowModal = useCallback(
    (title, text) => () => {
      setModalTitle(title);
      setModalText(text);
      setShowReasonModal(true);
    },
    [],
  );

  // Gift/Sales columns
  const giftSalesColumns = [
    { name: <>Order No</>, selector: (row) => row.order_id },
    {
      name: <>Order Date</>,
      selector: (row) => moment(row.order_date).format("DD-MM-YYYY"),
    },
    ...(tabKey === "teamCounter"
      ? [
          {
            name: <>Employee Name</>,
            selector: (row) => `${row.firstName} ${row.lastName}`,
          },
        ]
      : []),
    {
      name: <>Total</>,
      selector: (row) =>
        type === "gift" ? row.material_total : row.order_total,
    },
    {
      name: <>Action</>,
      cell: (row) => (
        <RB.Button
          className="btn-flat me-1"
          onClick={() => {
            setSelectedRow(row);
            setShowModal(true);
          }}
        >
          <Eye />
        </RB.Button>
      ),
    },
  ];

  // Select columns based on type
  const columns =
    type === "meeting"
      ? meetingColumns
      : type === "branding"
        ? brandColumns
        : giftSalesColumns;

  const handleBack = () => {
    navigate(-1);
  };

  const handlePageChange = (newPage) => {
    setPage(newPage);
  };

  useEffect(() => {
    if (!id || !type) return;

    if (type === "meeting") {
      utils
        .callAPI(
          "get",
          `/meeting/list-by-keypersion?key_person_id=${keyPersonId}&counter_id=${id}`,
        )
        .then((res) => setData(res || { result: [], total: 0 }))
        .catch(() => setData({ result: [], total: 0 }));
    } else if (type === "branding") {
      utils
        .callAPI(
          "get",
          `/meeting/branding/list-by-keypersion?key_person_id=${keyPersonId}&counter_id=${id}`,
        )
        .then((res) => setData(res || { result: [], total: 0 }))
        .catch(() => setData({ result: [], total: 0 }));
    } else if (type === "gift" || type === "sales") {
      const url = `sales/getOrdersListCounter?counter_id=${id}&key_persion_id=${keyPersonId}`;

      utils
        .callAPI("get", url)
        .then((res) => setData(res || { result: [], total: 0 }))
        .catch(() => setData({ result: [], total: 0 }));
    }
  }, [id, type, page]);

  const displayName =
    type === "meeting"
      ? data?.result?.[0]?.companyName
      : type === "branding"
        ? data?.result?.[0]?.dealership_name
        : type === "gift" || type === "sales"
          ? data?.result?.[0]?.channel_details?.companyName
          : "";

  return (
    <Layout>
      <div className="main-content">
        <section className="section">
          <div className="section-header">
            <h1>Counter Detail</h1>
          </div>
          <div className="section-body">
            <RB.Card className="card shadow">
              <RB.Card.Header>
                <h5>
                  {displayName}{" "}
                  {type === "meeting"
                    ? "Meeting Detail"
                    : type === "branding"
                      ? "Branding Detail"
                      : type === "gift"
                        ? "Gift Orders"
                        : type === "sales"
                          ? "Sales Orders"
                          : "Detail"}
                </h5>
                <div className="card-header-action">
                  <Link className="btn btn-underline me-2" onClick={handleBack}>
                    Back
                  </Link>
                </div>
              </RB.Card.Header>
              <RB.Card.Body>
                <DataTable
                  columns={columns}
                  data={data?.result || []}
                  highlightOnHover
                  responsive
                  pagination
                  paginationServer
                  paginationTotalRows={data.total}
                  paginationPerPage={countPerPage}
                  paginationComponentOptions={{ noRowsPerPage: true }}
                  paginationComponent={() => (
                    <CustomPagination
                      currentPage={page}
                      totalRows={data.total}
                      rowsPerPage={countPerPage}
                      onPageChange={handlePageChange}
                    />
                  )}
                  persistTableHead
                  striped
                />
              </RB.Card.Body>
            </RB.Card>
          </div>
        </section>
      </div>

      <RB.Modal show={showModal} onHide={() => setShowModal(false)} size="xl">
        <RB.Modal.Header closeButton>
          <RB.Modal.Title>
            {type === "gift"
              ? "Gift Material Details"
              : "Sales Product Details"}
          </RB.Modal.Title>
        </RB.Modal.Header>
        <RB.Modal.Body>
          {/* Sales Products */}
          {type === "sales" && (
            <>
              <h6>Products</h6>
              <hr className="hr-lg mt-1" />

              <RB.Card>
                <RB.CardBody className="p-3">
                  {/* Header row (only show on large screen) */}
                  <RB.Card className="mb-2 bg-light-subtle1 border-0 card rounded-0 d-none d-lg-block">
                    <RB.CardBody className="p-0">
                      <RB.Row className="gx-3 gy-2 align-items-center mb-2">
                        <RB.Col lg={2}>
                          <span className="text-uppercase fw-bold small text-body-secondary">
                            Product Category
                          </span>
                        </RB.Col>
                        <RB.Col lg={3}>
                          <span className="text-uppercase fw-bold small text-body-secondary">
                            Product
                          </span>
                        </RB.Col>
                        <RB.Col lg={2}>
                          <span className="text-uppercase fw-bold small text-body-secondary">
                            Sales Price
                          </span>
                        </RB.Col>
                        <RB.Col lg={2}>
                          <span className="text-uppercase fw-bold small text-body-secondary">
                            Qty
                          </span>
                        </RB.Col>
                        <RB.Col lg={2}>
                          <span className="text-uppercase fw-bold small text-body-secondary">
                            Total Amount In Rs.
                          </span>
                        </RB.Col>
                      </RB.Row>
                    </RB.CardBody>
                  </RB.Card>

                  {/* Products list */}
                  {selectedRow?.product?.map((product) => (
                    <RB.Card
                      key={product.id}
                      className="mb-2 bg-light-subtle1 border-0 border-bottom border-dashed card rounded-0"
                    >
                      <RB.CardBody className="p-0">
                        <RB.Row className="gx-3 gy-2 align-items-center">
                          <RB.Col lg={2}>
                            <div className="form-control-plaintext form-control-sm">
                              {product.category_name}
                            </div>
                          </RB.Col>
                          <RB.Col lg={3}>
                            <div className="form-control-plaintext form-control-sm">
                              {product.product_name}
                            </div>
                          </RB.Col>
                          <RB.Col lg={2}>
                            <div className="form-control-plaintext form-control-sm">
                              {product.sales_price}
                            </div>
                          </RB.Col>
                          <RB.Col lg={2}>
                            <div className="form-control-plaintext form-control-sm">
                              {product.qty}
                            </div>
                          </RB.Col>
                          <RB.Col lg={2}>
                            <div className="form-control-plaintext form-control-sm">
                              {product.sales_price * product.qty}
                            </div>
                          </RB.Col>
                        </RB.Row>
                      </RB.CardBody>
                    </RB.Card>
                  ))}

                  {/* Totals */}
                  <RB.Row className="g-3 justify-content-end align-items-center mt-3">
                    <RB.Col lg={2} className="text-end">
                      <h6 className="mb-0">Total Amount In Rs.</h6>
                    </RB.Col>
                    <RB.Col lg="auto">
                      <div className="bg-light bg-opacity-50 px-3 py-1 rounded-3">
                        <span className="text-uppercase fw-bold small text-body-secondary">
                          Quantity
                        </span>
                        <p className="fw-semibold mb-0">
                          {selectedRow?.order_total_qty || 0}
                        </p>
                      </div>
                    </RB.Col>
                    <RB.Col lg="auto">
                      <div className="bg-light bg-opacity-50 px-3 py-1 rounded-3">
                        <span className="text-uppercase fw-bold small text-body-secondary">
                          Price
                        </span>
                        <p className="fw-semibold mb-0">
                          {selectedRow?.order_total}
                        </p>
                      </div>
                    </RB.Col>
                  </RB.Row>
                </RB.CardBody>
              </RB.Card>
            </>
          )}

          {/* Gift Materials */}
          {type === "gift" && (
            <>
              <h6>Marketing Material</h6>
              <hr className="hr-lg mt-1" />
              <RB.Row className="gx-3 gy-2 fw-bold text-dark border-bottom pb-2 mb-2">
                <RB.Col lg={4}>Material Item</RB.Col>
                <RB.Col lg={2}>Price</RB.Col>
                <RB.Col lg={2}>Qty</RB.Col>
                <RB.Col lg={2}>Total Amount In Rs.</RB.Col>
              </RB.Row>
              {selectedRow?.material?.map((m) => (
                <RB.Card
                  key={m.id}
                  className="mb-2 bg-light-subtle1 border-0 border-bottom border-dashed card rounded-0"
                >
                  <RB.CardBody className="p-0">
                    <RB.Row className="gx-3 gy-2 align-items-center">
                      <RB.Col lg={4}>
                        <div className="form-control-plaintext form-control-sm">
                          {m.material_item_name}
                        </div>
                      </RB.Col>
                      <RB.Col lg={2}>
                        <div className="form-control-plaintext form-control-sm">
                          {m.price}
                        </div>
                      </RB.Col>
                      <RB.Col lg={2}>
                        <div className="form-control-plaintext form-control-sm">
                          {m.qty}
                        </div>
                      </RB.Col>
                      <RB.Col lg={2}>
                        <div className="form-control-plaintext form-control-sm">
                          {m.price * m.qty}
                        </div>
                      </RB.Col>
                    </RB.Row>
                  </RB.CardBody>
                </RB.Card>
              ))}

              {/* Totals */}
              <RB.Row className="g-3 justify-content-end align-items-center mt-3">
                <RB.Col lg={2} className="text-end">
                  <h6 className="mb-0">Total Amount In Rs.</h6>
                </RB.Col>
                <RB.Col lg="auto">
                  <div className="bg-light bg-opacity-50 px-3 py-1 rounded-3">
                    <span className="text-uppercase fw-bold small text-body-secondary">
                      Quantity
                    </span>
                    <p className="fw-semibold mb-0">
                      {selectedRow?.material_total_qty}
                    </p>
                  </div>
                </RB.Col>
                <RB.Col lg="auto">
                  <div className="bg-light bg-opacity-50 px-3 py-1 rounded-3">
                    <span className="text-uppercase fw-bold small text-body-secondary">
                      Price
                    </span>
                    <p className="fw-semibold mb-0">
                      {selectedRow?.material_total}
                    </p>
                  </div>
                </RB.Col>
              </RB.Row>
            </>
          )}
        </RB.Modal.Body>
      </RB.Modal>
      <ReasonModal
        show={showReasonModal}
        onHide={() => setShowReasonModal(false)}
        title={modalTitle}
        text={modalText}
      />
    </Layout>
  );
}

export default EmployeeAmountDetail;
